<template>
  <form
    action=""
    method="POST"
    @submit="onSubmit"
  >
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="nama_lengkap">Nama Lengkap</label>
          <input
            id="nama_lengkap"
            type="text"
            class="form-control" 
            name="text"
            required
            v-model="formPenduduk.nama_lengkap"
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label for="nik">NIK</label>
          <input
            id="nik"
            type="number"
            class="form-control" 
            name="email"
            required
            v-model="formPenduduk.nik"
            :disabled="aksi === 'edit' || aksi === 'edit-profil'"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="no_kk">No KK</label>
          <input
            id="no_kk"
            type="number"
            class="form-control" 
            name="email"
            required
            v-model="formPenduduk.no_kk"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="no_kk">Tempat Lahir</label>
          <input
            id="tempat_lahir"
            type="text"
            class="form-control" 
            name="tempat_lahir"
            required
            v-model="formPenduduk.tempat_lahir"
          >
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label for="tanggal_lahir">Tanggal Lahir</label>
          <input
            id="tanggal_lahir"
            type="date"
            class="form-control" 
            name="tanggal_lahir"
            required
            v-model="formPenduduk.tanggal_lahir"
          >
        </div>
      </div>
      <div class="col-sm-3">
        <div class="form-group">
          <label for="umur">Umur</label>
          <div class="input-group">
            <input
              id="tanggal_lahir"
              type="number"
              class="form-control text-right" 
              name="umur"
              disabled
              v-model="formPenduduk.umur"
            >
            <div class="input-group-append">
              <div class="input-group-text">
                Tahun
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="idKelaminL">Jenis Kelamin</label>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="idKelaminL"
              name="id_kelamin"
              class="custom-control-input"
              value="1"
              v-model="formPenduduk.id_kelamin"
            >
            <label
              class="custom-control-label"
              for="idKelaminL"
            >Laki-laki</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="idKelaminP"
              name="id_kelamin"
              class="custom-control-input"
              value="2"
              v-model="formPenduduk.id_kelamin"
            >
            <label
              class="custom-control-label"
              for="idKelaminP"
            >Perempuan</label>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="statusKawinKawin">Status Kawin</label>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="statusKawinKawin"
              name="status_kawin"
              class="custom-control-input"
              value="Kawin"
              v-model="formPenduduk.status_kawin"
            >
            <label
              class="custom-control-label"
              for="statusKawinKawin"
            >Kawin</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="statusKawinBelumKawin"
              name="status_kawin"
              class="custom-control-input"
              value="Belum Kawin"
              v-model="formPenduduk.status_kawin"
            >
            <label
              class="custom-control-label"
              for="statusKawinBelumKawin"
            >Belum Kawin</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="statusKawinCeraiHidup"
              name="status_kawin"
              class="custom-control-input"
              value="Cerai Hidup"
              v-model="formPenduduk.status_kawin"
            >
            <label
              class="custom-control-label"
              for="statusKawinCeraiHidup"
            >Cerai Hidup</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="statusKawinCeraiMati"
              name="status_kawin"
              class="custom-control-input"
              value="Cerai Mati"
              v-model="formPenduduk.status_kawin"
            >
            <label
              class="custom-control-label"
              for="statusKawinCeraiMati"
            >Cerai Mati</label>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label for="alamat">Alamat</label>
          <input
            id="alamat"
            type="text"
            class="form-control"
            name="alamat"
            required
            v-model="formPenduduk.alamat"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="kecamatan">Kecamatan</label>
          <v-select
            v-model="id_kecamatan"
            :options="optionKecamatan"
            label="nama_kecamatan"
            :loading="loadingKecamatan"
            :clearable="false"
            :disabled="aksi === 'edit' || aksi === 'edit-profil'"
          />
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="desa">Desa</label>
          <v-select
            v-model="formPenduduk.id_desa"
            :options="optionDesa"
            label="nama_desa"
            :loading="loadingDesa"
            :clearable="false"
            :disabled="aksi === 'edit' || aksi === 'edit-profil'"
          />
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="shdkKepalaKeluarga">Status Hubungan Dalam Keluarga</label>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkKepalaKeluarga"
              name="shdk"
              class="custom-control-input"
              value="1"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkKepalaKeluarga"
            >Kepala Keluarga</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkSuami"
              name="shdk"
              class="custom-control-input"
              value="2"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkSuami"
            >Suami</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkIstri"
              name="shdk"
              class="custom-control-input"
              value="3"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkIstri"
            >Istri</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkAnak"
              name="shdk"
              class="custom-control-input"
              value="4"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkAnak"
            >Anak</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkMenantu"
              name="shdk"
              class="custom-control-input"
              value="5"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkMenantu"
            >Menantu</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkCucu"
              name="shdk"
              class="custom-control-input"
              value="6"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkCucu"
            >Cucu</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkOrangTua"
              name="shdk"
              class="custom-control-input"
              value="7"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkOrangTua"
            >Orang Tua</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkMertua"
              name="shdk"
              class="custom-control-input"
              value="8"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkMertua"
            >Mertua</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="shdkFamiliLain"
              name="shdk"
              class="custom-control-input"
              value="9"
              v-model="formPenduduk.id_shdk"
            >
            <label
              class="custom-control-label"
              for="shdkFamiliLain"
            >Famili Lain</label>
          </div>
          <input
            type="hidden"
            v-model="formPenduduk.shdk"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="agamaHindu">Agama</label>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="agamaHindu"
              name="agama"
              class="custom-control-input"
              value="1"
              v-model="formPenduduk.id_agama"
            >
            <label
              class="custom-control-label"
              for="agamaHindu"
            >Hindu</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="agamaKatholik"
              name="agama"
              class="custom-control-input"
              value="2"
              v-model="formPenduduk.id_agama"
            >
            <label
              class="custom-control-label"
              for="agamaKatholik"
            >Katholik</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="agamaKristen"
              name="agama"
              class="custom-control-input"
              value="3"
              v-model="formPenduduk.id_agama"
            >
            <label
              class="custom-control-label"
              for="agamaKristen"
            >Kristen</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="agamaIslam"
              name="agama"
              class="custom-control-input"
              value="4"
              v-model="formPenduduk.id_agama"
            >
            <label
              class="custom-control-label"
              for="agamaIslam"
            >Islam</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="agamaBudha"
              name="agama"
              class="custom-control-input"
              value="5"
              v-model="formPenduduk.id_agama"
            >
            <label
              class="custom-control-label"
              for="agamaBudha"
            >Budha</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="agamaAliran"
              name="agama"
              class="custom-control-input"
              value="6"
              v-model="formPenduduk.id_agama"
            >
            <label
              class="custom-control-label"
              for="agamaAliran"
            >Aliran Kepercayaan</label>
          </div>
          <div class="custom-control custom-radio">
            <input
              type="radio"
              id="agamaHindu"
              name="agamaKongHuCu"
              class="custom-control-input"
              value="7"
              v-model="formPenduduk.id_agama"
            >
            <label
              class="custom-control-label"
              for="agamaKongHuCu"
            >Kong HuChu</label>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="pend_terakhir">Pendidikan Terakhir</label>
          <input
            id="pend_terakhir"
            type="text"
            class="form-control"
            name="pend_terakhir"
            required
            v-model="formPenduduk.pend_terakhir"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="pekerjaan">Pekerjaan</label>
          <input
            id="pekerjaan"
            type="text"
            class="form-control"
            name="pekerjaan"
            required
            v-model="formPenduduk.pekerjaan"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="nama_lengkap_ayah">Nama Ayah</label>
          <input
            id="nama_lengkap_ayah"
            type="text"
            class="form-control"
            name="nama_lengkap_ayah"
            required
            v-model="formPenduduk.nama_lengkap_ayah"
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="nama_lengkap_ibu">Nama Ibu</label>
          <input
            id="nama_lengkap_ibu"
            type="text"
            class="form-control"
            name="nama_lengkap_ibu"
            required
            v-model="formPenduduk.nama_lengkap_ibu"
          >
        </div>
      </div>
    </div>
    <div class="text-right">
      <b-button
        id="btnSubmitPenduduk"
        class="mx-1"
        type="submit"
        variant="primary"
      >
        {{ (aksi === 'tambah') ? 'Tambah' : 'Edit' }}
      </b-button>
      <b-button
        type="button"
        class="mx-1"
        @click="$bvModal.hide('modal-' + aksi + '-penduduk')"
      >
        Batal
      </b-button>
    </div>
  </form>
</template>

<script>
import swal from 'sweetalert'

export default {
  data () {
    return {
      formPenduduk: {
        nama_lengkap: '',
        nik: '',
        no_kk: '',
        id_kelamin: '',
        tempat_lahir: '',
        tanggal_lahir: '',
        umur: '',
        status_kawin: '',
        shdk: '',
        id_shdk: '',
        pend_terakhir: '',
        pekerjaan: '',
        id_agama: '',
        nama_lengkap_ayah: '',
        nama_lengkap_ibu: '',
        alamat: '',
        id_desa: '',
      },
      id_kecamatan: '',
      optionKecamatan: [{
        id_kecamatan: 0,
        nama_kecamatan: ''
      }],
      optionDesa: [{
        id_desa: 0,
        nama_desa: ''
      }],
      loadingKecamatan: false,
      loadingDesa: false,
    }
  },
  props: {
    aksi: {
      type: String,
      default: () => null
    },
    penduduk: {
      type: Object,
      default: () => null
    }
  },
  computed: {
		profile(){
			return this.$store.getters.getUserProfile
		}
  },
  mounted () {
    this.loadKecamatan()
    console.log(this.penduduk)
    if(this.aksi === 'edit'){
      this.setForm(this.penduduk)
    } else if(this.aksi === 'edit-profil') {
      this.setForm(this.profile)
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      if (this.formPenduduk.nama_lengkap.length > 100) {
        swal({
          title: "Gagal",
          text: "Nama lengkap terlalu panjang",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.nik.length !== 16) {
        swal({
          title: "Gagal",
          text: "NIK terdiri dari 16 angka",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.no_kk.length !== 16) {
        swal({
          title: "Gagal",
          text: "Nomor KK terdiri dari 16 angka",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_kelamin === '') {
        swal({
          title: "Gagal",
          text: "Jenis kelamin tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.status_kawin === '') {
        swal({
          title: "Gagal",
          text: "Status Perkawinan tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_shdk === '') {
        swal({
          title: "Gagal",
          text: "Status hubungan dalam keluarga tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_agama === '') {
        swal({
          title: "Gagal",
          text: "Agama tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }
      if (this.formPenduduk.id_desa === '') {
        swal({
          title: "Gagal",
          text: "Desa tidak boleh kosong",
          icon: "error",
          buttons: "Ok"
        })
        return false
      }


      let button = document.querySelector('#btnSubmitPenduduk')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-spinner mr-2"></i>Submit'

      let formData = new FormData()
      for (let key in this.formPenduduk) {
        if(key !== 'id_desa'){
          formData.append(key, this.formPenduduk[key])
        }
      }
      formData.append('id_desa', this.formPenduduk.id_desa.id_desa)

      let dispatchPenduduk = 'storePenduduk'
      if (this.aksi === 'tambah') {
        dispatchPenduduk = 'storePenduduk'
      } else if(this.aksi === 'edit') {
        dispatchPenduduk = 'updatePenduduk'
        formData = {
          id: this.penduduk.id_penduduk,
          form: formData
        }
      } else if(this.aksi === 'edit-profil') {
        dispatchPenduduk = 'updateProfilePenduduk'
      }

      this.$store.dispatch(dispatchPenduduk, formData).then((res) => {
        if (res.data.status) {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml

          swal({
            title: "Berhasil",
            text: res.data.message,
            icon: "success",
            buttons: "Ok"
          }).then(val => {
            this.$bvModal.hide('modal-' + this.aksi + '-penduduk')
          })
          this.$emit('completedProsesPenduduk')
        } else {
          button.removeAttribute('disabled')
          button.innerHTML = buttonHtml

          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml

        // console.log(err)
        if (typeof (err.response.data.message) === 'object') {
          swal({
            title: "Gagal",
            text: "Pendaftaran gagal. Periksa form kembali.",
            icon: "error",
            buttons: "Ok"
          })
        } else {
          swal({
            title: "Gagal",
            text: err.response.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      })
    },
    loadKecamatan() {
      this.loadingKecamatan = true
      this.$store.dispatch('fetchKecamatan', { id_kabupaten: 274 }).then(res => {
        if (res.data.status) {
          let optKec = []
          res.data.data.forEach(e => {
            optKec.push(e)
          })
          this.optionKecamatan = optKec
          this.loadingKecamatan = false

          if(this.aksi === 'edit'){
            this.id_kecamatan = this.optionKecamatan.find(e => e.id_kecamatan === this.penduduk.desa.id_kecamatan)
          } else if(this.aksi === 'edit-profil'){
            this.id_kecamatan = this.optionKecamatan.find(e => e.id_kecamatan === this.profile.desa.id_kecamatan)
          }
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
    },
    loadDesa() {
      this.loadingDesa = true
      this.$store.dispatch('fetchDesa', { id_kecamatan: this.id_kecamatan.id_kecamatan }).then(res => {
        if (res.data.status) {
          let optDes = []
          res.data.data.forEach(e => {
            optDes.push(e)
          })
          this.optionDesa = optDes
          this.loadingDesa = false

          if(this.aksi === 'edit'){
            this.formPenduduk.id_desa = this.optionDesa.find(e => e.id_desa === this.penduduk.id_desa)
          } else if(this.aksi === 'edit-profil'){
            this.formPenduduk.id_desa = this.optionDesa.find(e => e.id_desa === this.profile.id_desa)
          }
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
    },
    setForm(data) {
      if(this.profile){
        this.formPenduduk.nama_lengkap = data.nama_lengkap
        this.formPenduduk.nik = data.nik
        this.formPenduduk.no_kk = data.no_kk
        this.formPenduduk.id_kelamin = data.id_kelamin
        this.formPenduduk.tempat_lahir = data.tempat_lahir
        this.formPenduduk.tanggal_lahir = data.tanggal_lahir
        this.formPenduduk.umur = data.umur
        this.formPenduduk.status_kawin = data.status_kawin
        this.formPenduduk.shdk = data.shdk
        this.formPenduduk.id_shdk = data.id_shdk
        this.formPenduduk.pend_terakhir = data.pend_terakhir
        this.formPenduduk.pekerjaan = data.pekerjaan
        this.formPenduduk.id_agama = data.id_agama
        this.formPenduduk.nama_lengkap_ayah = data.nama_lengkap_ayah
        this.formPenduduk.nama_lengkap_ibu = data.nama_lengkap_ibu
        this.formPenduduk.alamat = data.alamat
        this.formPenduduk.id_desa = data.id_desa
      }
    }
  },
  watch: {
    id_kecamatan(newVal, oldVal) {
      this.loadDesa()
    },
    profile(newVal){
      if(this.aksi === 'edit-profil'){
        this.setForm(newVal)
      }
    },
    penduduk(newVal){
      if(this.aksi === 'edit'){
        this.setForm(newVal)
      }
    },
    'formPenduduk.tanggal_lahir'(newVal) {
      var today = new Date();
      var birthDate = new Date(newVal);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
      }
      this.formPenduduk.umur = age
    },
    'formPenduduk.id_shdk'(newVal) {
      const shdk = [
        'Kepala Keluarga',
        'Suami',
        'Istri',
        'Anak',
        'Menantu',
        'Cucu',
        'Orangtua',
        'Mertua',
        'Famili Lain',
        'Pembantu'
      ]
      let selShdk = shdk[parseInt(newVal) - 1]
      this.formPenduduk.shdk = selShdk
    }
  }
}
</script>